// extracted by mini-css-extract-plugin
module.exports = {"main":"QSRImageDrawer_main__r2U4f","productImage":"QSRImageDrawer_productImage__4zmwj"};